<p-table
	#dt
	[value]="venueService.licensesKitchenDevice.value"
	styleClass="p-datatable-responsive-demo"
	[loading]="!venueService.licensesKitchenDevice.value"
	[globalFilterFields]="app.keys(venueService.licensesKitchenDevice.value)"
	[scrollable]="true"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th>Name</th>
			<th>MAC Address</th>
			<th>App Version</th>
			<th>Printer ID</th>
			<th>IP Address</th>
			<th>Last Heartbeat</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="kitchenDeviceSelected = rec">
			<td>
				<span *ngIf="rec.claimed">
					{{ rec.name }}
				</span>
				<span *ngIf="!rec.claimed">
					<i>license available</i>
				</span>
			</td>
			<td>
				{{ rec.mac }}
			</td>
			<td>
				{{ rec.softwareVersion }}
			</td>
			<td>
				{{ rec.printerId }}
			</td>
			<td>
				{{ rec.ip }}
			</td>
			<td>
				<div *ngIf="rec.lastHeartbeat">
					{{ app.moment(rec.lastHeartbeat).format("l LT") }}
				</div>
			</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="6">
				<div class="p-datatable-emptymessage-wrapper">
					<span class="p-datatable-emptymessage"> No Kitchen Devices found </span>
				</div>
			</td>
		</tr>
	</ng-template>
</p-table>

<app-kitchen-device-setup *ngIf="kitchenDeviceSelected" [(kitchenDevice)]="kitchenDeviceSelected"></app-kitchen-device-setup>
